import { render, staticRenderFns } from "./GlobalCart.vue?vue&type=template&id=4b8168e0&scoped=true&"
import script from "./GlobalCart.vue?vue&type=script&lang=js&"
export * from "./GlobalCart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalCart.vue?vue&type=style&index=0&id=4b8168e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8168e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Upsells: require('/opt/build/repo/components/order/checkout/Upsells.vue').default})
